import { useMutation } from "@apollo/client";

import {
  DeleteClientInput,
  DeleteClientMutation,
  DeleteClientMutationVariables,
} from "../../API";
import { DELETE_CLIENT } from "../../common/operations/mutations";
import { successNotification } from "../../common/variables/notification";
import { handleApolloError } from "../../common/utils/handleApolloError";

export const useDeleteClient = () => {
  const [removeClient, { data, loading }] = useMutation<
    DeleteClientMutation,
    DeleteClientMutationVariables
  >(DELETE_CLIENT);

  const deleteClient = async (input: DeleteClientInput) => {
    await removeClient({
      variables: {
        input,
      },
      onCompleted: response => {
        const { deleteClient } = response;

        if (deleteClient) {
          successNotification(`${deleteClient.clientName} is deleted`);
        }
      },
      onError: handleApolloError,
      update(cache) {
        const normalizedId = cache.identify({
          id: input.clientId,
          __typename: "Client",
        });

        cache.evict({ id: normalizedId });

        cache.gc();
      },
    });
  };

  return { deleteClient, data, loading };
};
